'use client'

import React, { useEffect } from 'react'
import useAccordion from '@/hooks/useAccordion'
import { Logo } from '@/app/components/templates/non-block/Logo'
import { MainLogos } from '@/app/components/templates/non-block/MainLogos'
import { Logos } from '@/types/newt/logos'
import PartnershipForm from '@/app/components/forms/PartnershipForm'
import { Opportunity } from '@/types/newt/opportunity'
import LinkButton from '../parts/LinkButton'
import { QuestionPartnership } from './non-block/QuestionPartnership'

type PartnershipContentProps = {
  logo: any[]
  logos: Logos[]
  opportunities: Opportunity[]
}

const PartnershipPageTemplate: React.FC<PartnershipContentProps> = ({
  logo,
  logos,
  opportunities
}) => {
  useAccordion()
  useEffect(() => {}, [])
  return (
    <div>
      <main>
        <div className="bg-[#EFF3F7]">
          <div className="mx-auto w-full px-4 sm:px-6 lg:px-4 xl:px-0 lg:max-w-[1200px]">
            <div className="flex flex-col items-center lg:flex-row lg:justify-center">
              <div className="w-full px-4 pl-0 py-8 text-center lg:w-[750px] lg:text-left">
                <h1 className="text-xl font-bold text-textblack lg:text-3xl">
                  <span className="relative">
                    <span className="absolute -top-3 lg:top-[-1em] left-0 right-0 text-xs lg:text-sm font-normal">
                      ローグ
                    </span>
                    LAWGUE
                  </span>
                  を広くご紹介
                  <br className="lg:hidden" />
                  いただける
                  <br className="hidden lg:block" />
                  販売パートナー様を
                  <br className="lg:hidden" />
                  募集しております。
                </h1>
                <div className="mt-4 lg:mt-10">
                  <LinkButton
                    href="#form"
                    size="xlarge"
                    bg="visible"
                    label="今すぐ相談する"
                    onClick={() => {
                      const formElement = document.getElementById('form')
                      formElement?.scrollIntoView({ behavior: 'smooth' })
                    }}
                  />
                </div>
              </div>
              <div className="w-full md:w-[505px]">
                <div className="flex justify-center">
                  <img
                    src="/images/img_partnership_cover.svg"
                    alt=""
                    className="w-full"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2 className="py-8 text-center text-lg font-bold text-textblack sm:text-xl lg:text-2xl">
          数名規模から大手企業、官公庁で導入実績あり
          <br />
          中央省庁との取り組みも行っております
        </h2>
        <div className="mx-auto grid w-full max-w-[1280px] grid-cols-4 gap-2 px-2 sm:px-6 lg:grid-cols-8">
          {logos?.map((logos: Logos) => (
            <MainLogos key={logos._id} logos={logos} />
          ))}
        </div>

        <section className="bg-lawguebase mt-6">
          <div className="mx-auto max-w-7xl px-6 xl:px-0 py-16 lg:py-32">
            <div className="flex flex-col items-center md:flex-row justify-center">
              <figure>
                <img
                  src="/images/img_partnership_rizeupfesta.png"
                  alt=""
                  className="w-full"
                  decoding="async"
                />
              </figure>
              <div className="mt-6 w-full lg:mt-0 md:ml-[60px] sm:w-[676px]">
                <h2 className="text-center text-lg font-bold text-textblack md:text-left sm:text-xl lg:text-2xl">
                  &ldquo;Rise Up Festa&rdquo;のDX部門において
                  <br />
                  最優秀企業賞を受賞
                </h2>
                <p className="text-center mt-6 text-base leading-7 md:text-left">
                  &ldquo;Rise Up
                  Festa&rdquo;は三菱UFJ銀行が主催する新規性・独創性を有する事業や既存の事業領域を超えて、新たな事業に取り組んでいるベンチャー企業をサポートするビジネスコンテストです。LAWGUEは当コンテストのDX部門において最優秀企業賞を受賞いたしました。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="mx-auto max-w-7xl px-6 pb-0 py-16 text-center lg:pt-32">
            <h2 className="text-xl font-bold text-textblack lg:text-3xl">
              パートナープログラムのご説明
            </h2>
            <div className="mt-10 flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4 lg:mt-20">
              {/* セールスパートナー */}
              <div className="w-full md:w-1/2">
                <h3 className="rounded-t-lg bg-secondary px-6 py-2 text-left">
                  <span className="block text-2xl font-bold text-white sm:text-2xl">
                    セールスパートナー
                  </span>
                  <span className="block text-sm font-medium text-white">
                    代理販売をしていただく形式
                  </span>
                </h3>
                <img
                  src="/images/img_partnership_about01.svg"
                  alt=""
                  className="w-full"
                  decoding="async"
                />
              </div>
              {/* 紹介パートナー */}
              <div className="w-full md:w-1/2">
                <h3 className="rounded-t-lg bg-[#7FB2F0] px-6 py-2 text-left">
                  <span className="block text-2xl font-bold text-white sm:text-2xl">
                    紹介パートナー
                  </span>
                  <span className="block text-sm font-medium text-white">
                    お客様候補をご紹介いただく形式
                  </span>
                </h3>
                <img
                  src="/images/img_partnership_about02.svg"
                  alt=""
                  className="w-full"
                  decoding="async"
                />
              </div>
            </div>
          </div>

          {/* 比較表セクション */}
          <div className="mx-auto max-w-7xl px-6 py-10 text-center lg:py-20">
            {/* デスクトップ表示 */}
            <div className="hidden overflow-hidden rounded md:block">
              <table className="w-full border-separate text-sm">
                <tbody>
                  <tr>
                    <td className="rounded-tl bg-[#EDEDED] px-6 py-3 text-left">
                      形態
                    </td>
                    <th className="bg-secondary px-6 py-3 text-center text-white">
                      セールスパートナー
                    </th>
                    <th className="rounded-tr bg-[#7FB2F0] px-6 py-3 text-center text-white">
                      紹介パートナー
                    </th>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left">
                      商談アポイント
                    </td>
                    <td className="px-6 py-3 bg-[#cad8ef] text-center font-bold">
                      パートナー様
                    </td>
                    <td className="px-6 py-3 bg-[#d5e9fa] text-center font-bold">
                      パートナー様
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left">
                      商談対応
                    </td>
                    <td className="px-6 py-3 bg-[#cad8ef] text-center font-bold">
                      パートナー様
                    </td>
                    <td className="px-6 py-3 bg-[#d5e9fa] text-center font-bold">
                      FRAIM社
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left rounded-bl">
                      受注後フォロー
                    </td>
                    <td className="px-6 py-3 bg-[#cad8ef] text-center font-bold">
                      FRAIM社
                    </td>
                    <td className="px-6 py-3 bg-[#d5e9fa] text-center font-bold rounded-br">
                      FRAIM社
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* モバイル表示 */}
            <div className="md:hidden">
              <table className="w-full text-sm table border-separate">
                <tbody>
                  <tr>
                    <th
                      className="px-6 py-3 bg-secondary text-white text-center p-4 rounded-tl rounded-tr"
                      colSpan={2}
                    >
                      セールスパートナー
                    </th>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left">
                      商談アポイント
                    </td>
                    <td className="px-6 py-3 bg-[#cad8ef] text-center font-bold">
                      パートナー様
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left">
                      商談対応
                    </td>
                    <td className="px-6 py-3 bg-[#cad8ef] text-center font-bold">
                      パートナー様
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left rounded-bl">
                      受注後フォロー
                    </td>
                    <td className="px-6 py-3 bg-[#cad8ef] text-center font-bold rounded-br">
                      FRAIM社
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="w-full text-sm table border-separate mt-4 lg:mt-0">
                <tbody>
                  <tr>
                    <th
                      className="px-6 py-3 bg-[#7FB2F0] text-white text-center p-4 rounded-tl rounded-tr"
                      colSpan={2}
                    >
                      紹介パートナー
                    </th>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left">
                      商談アポイント
                    </td>
                    <td className="px-6 py-3 bg-[#d5e9fa] text-center font-bold">
                      パートナー様
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left">
                      商談対応
                    </td>
                    <td className="px-6 py-3 bg-[#d5e9fa] text-center font-bold">
                      FRAIM社
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-3 bg-[#EDEDED] text-left rounded-bl">
                      受注後フォロー
                    </td>
                    <td className="px-6 py-3 bg-[#d5e9fa] text-center font-bold rounded-br">
                      FRAIM社
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* メリットセクション */}
        <section>
          <div className="mx-auto max-w-7xl px-6 xl:px-0 py-16 text-center lg:py-32">
            <h2 className="text-xl font-bold text-textblack lg:text-3xl">
              パートナー様のメリット
            </h2>
            <div className="mt-6 grid grid-cols-1 gap-8 lg:mt-14 md:grid-cols-3">
              {[
                {
                  title: '企業規模・業種を問わず\n拡販が可能',
                  num: '01'
                },
                {
                  title: '継続率が高く定常的な\n収益が見込めます',
                  num: '02'
                },
                {
                  title: '運用サポートを気にせず\n営業活動に集中可能',
                  num: '03'
                }
              ].map(({ title, num }) => (
                <div key={num} className="flex flex-col items-center">
                  <img
                    src={`/images/img_partnership_merit${num}.svg`}
                    className="max-w-[280px]"
                    alt=""
                    decoding="async"
                  />
                  <p className="mt-0 font-robot font-bold text-2xl text-primary lg:text-5xl">
                    {num}
                  </p>
                  <h3 className="text-base font-bold text-textblack lg:text-2xl whitespace-pre-line">
                    {title}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 契約フローセクション */}
        <section>
          <div className="mx-auto max-w-7xl px-6 xl:px-0 py-16 text-center lg:py-32">
            <h2 className="text-xl font-bold text-textblack lg:text-3xl">
              ご契約までの流れ
            </h2>
            <p className="mt-6 text-base text-darken">
              最短で約１週間でのご契約可能です
            </p>

            {/* デスクトップ表示 */}
            <div className="mt-10 hidden lg:block lg:mt-20">
              <ol className="flex partner-step">
                {[
                  { step: '01', title: 'お問い合わせ' },
                  { step: '02', title: 'お打ち合わせ' },
                  { step: '03', title: '審査' },
                  { step: '04', title: 'ご契約内容の確認' },
                  { step: '05', title: '契約締結' }
                ].map(({ step, title }) => (
                  <li key={step} className="flex partner-step__item">
                    <div className="partner-step__icon">
                      <img
                        src={`/images/img_partnership_flow${step}.svg`}
                        alt=""
                        decoding="async"
                      />
                    </div>
                    <h3 className="partner-step__title text-base text-primary font-bold mb-1">
                      STEP {step}
                    </h3>
                    <p className="partner-step__desc text-lg font-bold">
                      {title}
                    </p>
                  </li>
                ))}
              </ol>
            </div>

            {/* モバイル表示 */}
            <div className="lg:hidden p-4 mt-4">
              <ol className="space-y-1">
                {[
                  { step: '01', title: 'お問い合わせ' },
                  { step: '02', title: 'お打ち合わせ' },
                  { step: '03', title: '審査' },
                  { step: '04', title: 'ご契約内容の確認' },
                  { step: '05', title: '契約締結' }
                ].map(({ step, title }) => (
                  <li key={step} className="partner-step__item_sp">
                    <div className="partner-step__icon_sp">
                      <img
                        src={`/images/img_partnership_flow${step}.svg`}
                        alt=""
                        decoding="async"
                      />
                    </div>
                    <div className="partner-step__content_sp">
                      <h3 className="text-sm font-bold text-primary">
                        STEP {step}
                      </h3>
                      <p className="text-lg font-bold">{title}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </section>

        {/* メリットセクション */}
        <section>
          <div className="mx-auto max-w-7xl px-6 xl:px-0 py-16 text-center lg:py-32">
            <h2 className="text-xl font-bold text-textblack lg:text-3xl">
              ご契約後のサポートについて
            </h2>
            <p className="mt-6 text-base text-darken">
              ご契約後、ただ「販売してください」ではなく、
              <br className="lg:hidden" />
              パートナー様ご自身で商談獲得・ご販売いただけるよう、
              <br className="lg:hidden" />
              伴走してご支援いたします
            </p>
            <div className="mt-6 grid grid-cols-1 gap-8 lg:mt-14 md:grid-cols-3">
              {/* サポートボックス1 */}
              <div className="flex flex-col items-center">
                <img
                  decoding="async"
                  src="/images/img_partnership_support01.svg"
                  alt=""
                  className="max-w-[280px]"
                />
                <h3 className="mt-2 text-base font-bold text-textblack lg:text-2xl">
                  営業サポート
                </h3>
                <p className="mt-2 text-sm leading-7 text-textblack lg:text-base">
                  商談創出支援、商談同席
                  <br />
                  営業資料の提供
                </p>
              </div>
              {/* サポートボックス2 */}
              <div className="flex flex-col items-center">
                <img
                  decoding="async"
                  src="/images/img_partnership_support02.svg"
                  alt=""
                  className="max-w-[280px]"
                />
                <h3 className="mt-2 text-base font-bold text-textblack lg:text-2xl">
                  学習サポート
                </h3>
                <p className="mt-2 text-sm leading-7 text-textblack lg:text-base">
                  勉強会、デモ練習
                  <br />
                  事例共有
                </p>
              </div>
              {/* サポートボックス3 */}
              <div className="flex flex-col items-center">
                <img
                  decoding="async"
                  src="/images/img_partnership_support03.svg"
                  alt=""
                  className="max-w-[280px]"
                />
                <h3 className="mt-2 text-base font-bold text-textblack lg:text-2xl">
                  その他サポート
                </h3>
                <p className="mt-2 text-sm leading-7 text-textblack lg:text-base">
                  各種お打ち合わせや
                  <br />
                  必要に応じたご支援
                </p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="mx-auto px-6 xl:px-0 py-16 text-center md:py-32 bg-white max-w-[1200px]">
            <h2 className="text-base font-bold text-textblack md:text-2xl">
              他にも、数多くの企業様に
              <br className="md:hidden" />
              ご利用いただいています
            </h2>
            <div className="mt-8 md:mt-16">
              <div className="m-auto max-w-[1176px] flex flex-wrap justify-start items-center gap-x-[3.9%] gap-y-[40px] lg:gap-y-[42px] px-1 lg:px-12">
                {logo.map((logoItem) => (
                  <Logo key={logoItem._id} logo={logoItem} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <QuestionPartnership />

        <section className="bg-formbg">
          <div className="mx-auto px-6 py-12 max-w-5xl">
            <div className="bg-white p-6 lg:p-20" id="form">
              <h2 className="text-lg font-bold text-textblack lg:text-2xl text-center">
                パートナーシップに関する
                <br className="lg:hidden" />
                お問い合わせ
              </h2>
              <PartnershipForm opportunities={opportunities} />
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}

export default PartnershipPageTemplate
